var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0715 5.60277C10.3095 5.36479 10.3095 4.97896 10.0715 4.74098C9.83354 4.50301 9.44771 4.50301 9.20973 4.74098L5.98438 7.96634L4.79027 6.77223C4.55229 6.53426 4.16646 6.53426 3.92848 6.77223C3.69051 7.01021 3.69051 7.39604 3.92848 7.63402L5.55348 9.25902C5.79146 9.49699 6.17729 9.49699 6.41527 9.25902L10.0715 5.60277Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C10.5899 0.5 13.5 3.41015 13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7ZM1.71875 7C1.71875 4.08325 4.08325 1.71875 7 1.71875C9.91675 1.71875 12.2812 4.08325 12.2812 7C12.2812 9.91675 9.91675 12.2812 7 12.2812C4.08325 12.2812 1.71875 9.91675 1.71875 7Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0715 5.60277C10.3095 5.36479 10.3095 4.97896 10.0715 4.74098C9.83354 4.50301 9.44771 4.50301 9.20973 4.74098L5.98438 7.96634L4.79027 6.77223C4.55229 6.53426 4.16646 6.53426 3.92848 6.77223C3.69051 7.01021 3.69051 7.39604 3.92848 7.63402L5.55348 9.25902C5.79146 9.49699 6.17729 9.49699 6.41527 9.25902L10.0715 5.60277Z",
    stroke: "currentColor",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C10.5899 0.5 13.5 3.41015 13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7ZM1.71875 7C1.71875 4.08325 4.08325 1.71875 7 1.71875C9.91675 1.71875 12.2812 4.08325 12.2812 7C12.2812 9.91675 9.91675 12.2812 7 12.2812C4.08325 12.2812 1.71875 9.91675 1.71875 7Z",
    stroke: "currentColor",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.0a59c961f13e3d11dc07ef10dac90313.svg";
export { ForwardRef as ReactComponent };